export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/airport-shopping.b506a79a-5bb1b5.png";